/**
 * Client-side random selection helpers for Spin the Wheel.
 * Inject `random` in tests for determinism. Not cryptographic.
 */

export type RandomFn = () => number;

/**
 * Pick one item uniformly. When `excludeId` is set and more than one item
 * remains after exclusion, avoid immediate repetition.
 */
export function pickRandomStrain<T extends { id: string }>(
  items: readonly T[],
  options: {
    excludeId?: string | null;
    random?: RandomFn;
  } = {},
): T | null {
  if (items.length === 0) return null;
  const random = options.random ?? Math.random;
  let pool = items;
  if (
    options.excludeId != null &&
    items.length > 1 &&
    items.some((i) => i.id === options.excludeId)
  ) {
    const filtered = items.filter((i) => i.id !== options.excludeId);
    if (filtered.length > 0) pool = filtered;
  }
  const index = Math.floor(random() * pool.length);
  const clamped = Math.min(Math.max(index, 0), pool.length - 1);
  return pool[clamped] ?? null;
}
